import { Modal } from '@arcadiapower/shrike';
import styled from 'styled-components';

export const StyledDialogModal = styled(Modal)`
  [data-reach-dialog-content] {
    padding: 0;
    height: 100%;
    overflow-x: hidden;
    position: fixed;
  }
`;

export const StyledDialogDesktopModal = styled(Modal)`
  [data-reach-dialog-content] {
    padding: 0;
    height: 742px;
  }
`;

export const StyledMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px;
  gap: 24px;
  left: 0px;
  height: 100%;
`;

export const StyledDesktopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 32px;
  gap: 24px;
  height: 100%;
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  align-self: stretch;
  flex: none;
  order: 0;
  flex-grow: 0;
  min-height: 32px;
  position: relative;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const ImageFlexBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 8px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
`;

export const TextButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
`;
